var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1491_506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 8.16146C9.69171 8.16146 11.3333 6.51984 11.3333 4.49479C11.3333 2.46975 9.69171 0.828125 7.66667 0.828125C5.64162 0.828125 4 2.46975 4 4.49479C4 6.51984 5.64162 8.16146 7.66667 8.16146Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 9.28906C10.356 9.28906 9.29199 10.3531 9.29199 11.6637C9.29199 12.9744 10.356 14.0391 11.6667 14.0391C12.9773 14.0391 14.042 12.9744 14.042 11.6637C14.042 10.3531 12.9773 9.28906 11.6667 9.28906ZM11.6667 10.2891C12.4253 10.2891 13.042 10.9051 13.042 11.6637C13.042 12.4224 12.4253 13.0391 11.6667 13.0391C10.908 13.0391 10.2913 12.4224 10.2913 11.6637C10.2913 10.9051 10.908 10.2891 11.6667 10.2891Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.166 9.78873V8.66406C12.166 8.38806 11.942 8.16406 11.666 8.16406C11.39 8.16406 11.166 8.38806 11.166 8.66406V9.7894C11.166 10.0647 11.39 10.2894 11.666 10.2894C11.942 10.2887 12.166 10.0647 12.166 9.78873Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3455 10.6921L14.1409 9.89614C14.3362 9.70147 14.3362 9.38414 14.1409 9.18947C13.9462 8.99414 13.6289 8.99414 13.4342 9.18947L12.6382 9.9848C12.4435 10.1801 12.4435 10.4968 12.6382 10.6921C12.8335 10.8868 13.1502 10.8868 13.3455 10.6921Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5413 12.1641H14.6667C14.9427 12.1641 15.1667 11.9401 15.1667 11.6641C15.1667 11.3881 14.9427 11.1641 14.6667 11.1641H13.5413C13.266 11.1641 13.042 11.3881 13.042 11.6641C13.0413 11.9401 13.266 12.1641 13.5413 12.1641Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6382 13.3455L13.4342 14.1409C13.6289 14.3362 13.9462 14.3362 14.1409 14.1409C14.3362 13.9462 14.3362 13.6289 14.1409 13.4342L13.3455 12.6382C13.1502 12.4435 12.8335 12.4435 12.6382 12.6382C12.4435 12.8335 12.4435 13.1502 12.6382 13.3455Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.166 13.5391V14.6644C11.166 14.9404 11.39 15.1644 11.666 15.1644C11.942 15.1644 12.166 14.9404 12.166 14.6644V13.5391C12.166 13.2637 11.942 13.0397 11.666 13.0391C11.39 13.0391 11.166 13.2637 11.166 13.5391Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98676 12.6382L9.19142 13.4342C8.99609 13.6289 8.99609 13.9462 9.19142 14.1409C9.38609 14.3362 9.70342 14.3362 9.89809 14.1409L10.6941 13.3455C10.8888 13.1502 10.8888 12.8335 10.6941 12.6382C10.4988 12.4435 10.1821 12.4435 9.98676 12.6382Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79068 11.1641H8.66602C8.39002 11.1641 8.16602 11.3881 8.16602 11.6641C8.16602 11.9401 8.39002 12.1641 8.66602 12.1641H9.79068C10.0667 12.1641 10.2913 11.9401 10.2907 11.6641C10.2907 11.3881 10.0667 11.1641 9.79068 11.1641Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6941 9.9848L9.89809 9.18947C9.70342 8.99414 9.38609 8.99414 9.19142 9.18947C8.99609 9.38414 8.99609 9.70147 9.19142 9.89614L9.98676 10.6921C10.1821 10.8868 10.4988 10.8868 10.6941 10.6921C10.8888 10.4968 10.8888 10.1801 10.6941 9.9848Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62367 14.501C8.26767 14.0437 8.29967 13.3804 8.72034 12.9604L8.84967 12.8304H8.66634C8.02234 12.8304 7.49967 12.3077 7.49967 11.6637C7.49967 11.0197 8.02234 10.497 8.66634 10.497H8.84967L8.72034 10.367C8.28301 9.93038 8.26567 9.23104 8.66834 8.77304C8.34167 8.74771 8.00701 8.73438 7.66634 8.73438C5.45167 8.73438 3.49101 9.28838 2.27367 10.1184C1.34501 10.7517 0.833008 11.5564 0.833008 12.401V13.3677C0.833008 13.6684 0.952341 13.957 1.16501 14.169C1.37767 14.3817 1.66567 14.501 1.96634 14.501H8.62367Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2ad08b0fc18d1cff06b3c4cb92f1c5d7.svg";
export { ForwardRef as ReactComponent };